import { render, staticRenderFns } from "./Spir.vue?vue&type=template&id=998b4ece"
import script from "./Spir.vue?vue&type=script&lang=ts"
export * from "./Spir.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports